import React, {useMemo} from "react"
import {useSiren} from "./SirenContext";
import {Layout} from "./Layout";
import {ImportHistory} from "./subpages/ImportHistory";
import {NewImport} from "./subpages/NewImport";
import {ImportManagementProvider} from "./ImportManagementContext";

export function Import() {

    const {subMenuCurrent, clientID} = useSiren()

    const page = useMemo(() => {
        switch (subMenuCurrent) {
            case "new_import":
                return <NewImport/>
            case "import_history":
                return <ImportHistory/>
        }

        return null
    }, [subMenuCurrent])

    return (
        <Layout menuCurrent={"import"}>
            <ImportManagementProvider clientID={clientID}>
                {page}
            </ImportManagementProvider>
        </Layout>
    )


}